// resetShorts.js
'use strict';
import { MERGE_OPERATION_DATA, SET_LIST_ITEMS } from '../ActionTypes.js';

import getOperationData from '../selector/getOperationData.js';

/**
 * Reset short ids and last watched index
 * @kind action
 * @param {string} {category} - feed alias.
 * @return {Promise} Action promise.
 */
const resetShorts =
  ({ category, index = 0 } = {}) =>
  async (dispatch, getState) => {
    const feedId = getOperationData(
      getState(),
      ['fetchedRenewFeedId', category],
      'id'
    );
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['feed', feedId],
        data: {
          lastWatchedIndex: index,
        },
      },
    });
    return dispatch({
      type: SET_LIST_ITEMS,
      payload: {
        selectPath: ['shorts', category],
        itemIds: [],
      },
    });
  };

export default resetShorts;
